import { Component,  ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';
import { PixFavoredMenu } from '../../../models/favored-menu.enum';

@Component({
	selector: 'app-pix-payment-key-favored-create-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixPaymentKeyMenuComponent {
	@Input() selectedPixFavoredMenu: PixFavoredMenu;
	@Output() selectKeyTypeEmitter = new EventEmitter<PixFavoredMenu>();

	constructor(public dialog: MatDialog) {}

	select(item: PixFavoredMenu) {
		this.selectedPixFavoredMenu = item;
		this.selectKeyTypeEmitter.emit(item);
	}

	get pixFavoredMenu(): typeof PixFavoredMenu {
		return PixFavoredMenu;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/payment-key/favored-create/menu/menu.component.ts